export { default as MainC } from './components/main';
export { default as AddC } from './components/add';
export { default as PenalizacionCancelacionC } from './components/penalizacionCancelacion';



// WEBPACK FOOTER //
// src/modules/rutinas/component.js